<template>
  <div>
    <v-data-table
      :sort-by="['createdAt']"
      :sort-desc="[true]"
      v-model="selectedCertifications"
      :showSelect="
        safeItems.length > 0 &&
        $store.state.role == 'ao' &&
        title == 'Certification Requests'
      "
      item-key="certificationId"
      :loading="isLoading"
      :headers="headers"
      :items="safeItems"
      :items-per-page="10"
      :search="search"
      class="elevation-1 mb-10"
      @click:row="onRowClick"
      style="cursor: pointer"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <b>{{ $t(title) }}</b>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="search-bar">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('table.search')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>

          <v-text-field
            v-model="fromdate"
            placeholder="Placeholder"
            type="date"
            single-line
            hide-details
            label="From date"
          ></v-text-field>

          <v-text-field
            v-model="todate"
            type="date"
            single-line
            hide-details
            label="To date"
          ></v-text-field>

          <v-btn @click="searchByDtRange()" color="primary" dark>
            Search
          </v-btn>

          <v-spacer></v-spacer>

          <div class="text-center mr-5" v-if="$route.name == 'Certifications'">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <a
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  style="text-decoration: underline"
                  >{{ $t("table.export") }}</a
                >
              </template>
              <v-list>
                <!-- Need to include click action to have hover animation -->
                <JsonExcel :data="safeItems" type="csv" :name="title + '.csv'">
                  <v-list-item @click="onExportCsv()">
                    <v-list-item-title>CSV</v-list-item-title>
                  </v-list-item>
                </JsonExcel>
                <v-list-item @click="onExportPdf()">
                  <!-- Need to include click action to have hover animation -->
                  <v-list-item-title>PDF</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-btn
            tile
            style="color: #fff"
            class="mb-2 primary-color"
            v-if="
              safeItems.length > 0 &&
              $store.state.role == 'ao' &&
              title == 'Certification Requests'
            "
            :disabled="selectedCertifications.length <= 0"
            @click="onApproveCertifications()"
            >Approve selected</v-btn
          >
        </v-toolbar>
      </template>

      <!-- Edit Modal -->
      <template
        v-slot:item.actions="{ item }"
        v-if="$store.state.role != 'centre'"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="mr-1"
              v-bind="attrs"
              v-on="on"
              @click.stop="onModerationCertification(item)"
              >mdi-cancel</v-icon
            >
          </template>
          <span>{{ $t("Set moderation required") }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="mr-1"
              v-bind="attrs"
              v-on="on"
              @click.stop="onEditCertification(item)"
              >mdi-pencil</v-icon
            >
          </template>
          <span>{{ $t("table.edit") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Edit certification modal -->
    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="headline"> Edit awarded date </v-card-title>

        <v-container>
          <v-row>
            <v-col cols="12">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="awardedDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="awardedDate"
                    label="Awarded Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="awardedDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(awardedDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>

          <v-btn color="green darken-1" text @click="onAmendAwardedDate()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: {
    JsonExcel,
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedCertificationId: null,
    awardedDate: null,
    date: null,
    fromdate: "",
    todate: "",
    menu: false,
    dialog: false,
    show: false,
    search: "",
    deleteDialog: false,
    pdfData: null,
    pdfHeader: [
      { text: "Username", style: "tableHeader" },
      { text: "Email", style: "tableHeader" },
      { text: "Role", style: "tableHeader" },
    ],
    selectedCertifications: [],
  }),
  computed: {
    safeItems() {
      return Array.isArray(this.items) ? this.items : [];
    },
  },
  methods: {
    searchByDtRange: async function () {
      this.$emit("setDateRangeData", {
        fromdate: this.fromdate,
        todate: this.todate,
      });
    },
    onAmendAwardedDate: async function () {
      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/certifications/${this.selectedCertificationId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify({ certificationIssueDate: this.awardedDate }),
        }
      );

      const data = await response.json();
      this.dialog = false;
      this.$emit("amendAwardedDate", data.message);
    },
    onModerationCertification(item) {
      const confirmRes = window.confirm(
        `Are you sure set to moderation pending?`
      );
      if (confirmRes) {
        this.onCertificationModOption(item.certificationId);
      }
    },
    onCertificationModOption: function (id) {
      fetch(`${process.env.VUE_APP_ROOT_API}/certifications/moderation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify({ id }),
      })
        .then((response) => response.json())
        .then((data) => {
          alert(data.message);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onEditCertification: function (item) {
      this.dialog = true;

      if (item.certificationIssueDate) {
        if (item.certificationIssueDate.includes("/")) {
          const formattedDate = item.certificationIssueDate.split("/");
          this.awardedDate =
            formattedDate[2] + "-" + formattedDate[1] + "-" + formattedDate[0];
        } else {
          this.awardedDate = item.certificationIssueDate;
        }
      } else {
        this.awardedDate = null;
      }

      this.selectedCertificationId = item.certificationId;
    },
    onApproveCertifications: async function () {
      const certificationIds = this.selectedCertifications.map(
        (cert) => cert.certificationId
      );

      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/certifications/batch`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify({ certificationIds }),
        }
      );

      await response.json();
      this.$emit("approveCertifications");
    },
    onRowClick(item) {
      this.$router.push({
        path: "pending-certifications/details",
        query: {
          id: item.certificationId,
          learnerId: item.learnerId,
        },
      });
    },
    onExportCsv: function () {
      console.log("Exporting csv...");
    },
    onExportPdf: function () {
      this.pdfData = this.safeItems.map((item) => [
        item.username,
        item.email,
        item.role,
      ]);

      this.pdfData.unshift(this.pdfHeader);

      var doc = {
        content: [
          { text: `${this.title} List`, style: "header" },
          {
            style: "tableExample",
            table: {
              widths: ["*", "*", "*"],
              headerRows: 1,
              body: this.pdfData,
            },
          },
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
        },
      };
      pdfMake.createPdf(doc).open();
    },
  },
};
</script>

<style scoped>
.search-bar {
  width: 200px;
}
</style>
